export default {
	props: {
		title: {
			type: String,
			default: 'Title'
		}
	},

	template: `
		<div class="bs-ed-dialog bs-ed-dialog-with-backdrop">
			<div class="bs-ed-dialog-dialog">
				<div class="bs-ed-dialog-content">
					<div class="bs-ed-dialog-title">
						{{title}}
					</div>
					<div class="bs-ed-dialog-subtitle">
						<slot></slot>
					</div>
					<div class="bs-ed-dialog-actions">
						<slot name="buttons">
							<button type="button" class="bs-ed-btn bs-ed-btn-primary" @click="$emit('ok')">
								OK
							</button>
						</slot>
					</div>
				</div>
			</div>
		</div>
	`
}
